import { useTheme } from "../context/ThemeContext";

const pillars = [
  { name: "Fast", tag: "Media", desc: "Studio to seat in one closed loop.", color: "#F2A900" },
  { name: "Lean", tag: "Platform", desc: "Same quality. Less spend.", color: "#10B981" },
  { name: "Personal", tag: "Entertainment", desc: "Content and UX tailored to every route.", color: "#A855F7" },
  { name: "Intelligent", tag: "Engagement", desc: "AI-powered curation and recommendation.", color: "#3B82F6" },
];

const SlideFourPillars = () => {
  const { isDark } = useTheme();
  return (
    <div>
      <div className="k-eyebrow" style={{ color: isDark ? "rgba(255,255,255,0.55)" : "rgba(0,0,0,0.5)" }}>
        The Aeroplay Way
      </div>
      <h2 className={`k-h2 mt-3 max-w-[16ch] ${isDark ? "text-white" : "text-[#1d1d1f]"}`}>
        Four pillars.
        <br />
        <span style={{ color: "var(--k-accent)" }}>One story.</span>
      </h2>
      <p className={`k-lead mt-6 max-w-[52ch] ${isDark ? "text-white/70" : "text-black/60"}`}>
        Four commitments that shape how we transform inflight entertainment
        for our airline partners.
      </p>

      <ol className={`mt-10 divide-y ${isDark ? "divide-white/10 border-y border-white/10" : "divide-black/10 border-y border-black/10"}`}>
        {pillars.map((p, i) => (
          <li key={p.name} className="grid grid-cols-12 items-baseline gap-6 py-4">
            <div className="col-span-1 k-eyebrow" style={{ color: isDark ? "rgba(255,255,255,0.35)" : "rgba(0,0,0,0.35)" }}>
              0{i + 1}
            </div>
            <div className="col-span-3">
              <div className={`text-[26px] lg:text-[32px] font-semibold tracking-tight leading-none ${isDark ? "text-white" : "text-[#1d1d1f]"}`}>
                {p.name}
              </div>
              <div className="mt-1.5 k-eyebrow" style={{ color: p.color }}>{p.tag}</div>
            </div>
            <p className={`col-span-8 text-[17px] leading-snug tracking-tight ${isDark ? "text-white/75" : "text-black/70"}`}>
              {p.desc}
            </p>
          </li>
        ))}
      </ol>
    </div>
  );
};

export default SlideFourPillars;
